import { createContext, useContext, useReducer, ReactNode } from 'react'

// 平台说明弹窗参数类型定义
interface PlatformModalParams {
  onOk?: () => void
  [key: string]: any
}

// 平台说明弹窗状态类型定义
interface PlatformModalState {
  showPlatformModal: boolean
  params: PlatformModalParams
}

// 平台说明弹窗动作类型
type PlatformModalAction = { type: 'SHOW_PLATFORM_MODAL'; params?: PlatformModalParams } | { type: 'HIDE_PLATFORM_MODAL' }

// 初始状态
const initialState: PlatformModalState = {
  showPlatformModal: false,
  params: {}
}

// Reducer
const platformModalReducer = (state: PlatformModalState, action: PlatformModalAction): PlatformModalState => {
  switch (action.type) {
    case 'SHOW_PLATFORM_MODAL':
      return {
        ...state,
        showPlatformModal: true,
        params: action.params || {}
      }
    case 'HIDE_PLATFORM_MODAL':
      return {
        ...state,
        showPlatformModal: false,
        params: {}
      }
    default:
      return state
  }
}

// Context
const PlatformModalContext = createContext<{
  state: PlatformModalState
  dispatch: React.Dispatch<PlatformModalAction>
} | null>(null)

// Provider组件
export const PlatformModalProvider = ({ children }: { children: ReactNode }) => {
  const [state, dispatch] = useReducer(platformModalReducer, initialState)

  return <PlatformModalContext.Provider value={{ state, dispatch }}>{children}</PlatformModalContext.Provider>
}

// Hook
export const usePlatformModalContext = () => {
  const context = useContext(PlatformModalContext)
  if (!context) {
    throw new Error('usePlatformModalContext must be used within a PlatformModalProvider')
  }
  return context
}

// 便捷的Hook
export const usePlatformModal = () => {
  const { state, dispatch } = usePlatformModalContext()

  const showPlatformModal = (params?: PlatformModalParams) => {
    dispatch({ type: 'SHOW_PLATFORM_MODAL', params })
  }

  const hidePlatformModal = () => {
    dispatch({ type: 'HIDE_PLATFORM_MODAL' })
  }

  return {
    showPlatformModal,
    hidePlatformModal,
    isPlatformModalVisible: state.showPlatformModal,
    params: state.params
  }
}
